/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { colors } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

const CaseStudy1 = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      padding={{ xs: 2, sm: 4 }}
      borderRadius={2}
      bgcolor={
        theme.palette.mode === 'light' ? colors.blue[50] : colors.blue[900]
      }
      data-aos={'fade-up'}
    >
      <Grid
        container
        spacing={isMd ? 4 : 2}
        flexDirection={{ xs: 'column-reverse', md: 'row' }}
      >
        <Grid item xs={12} md={8}>
          <Grid container spacing={isMd ? 4 : 2}>
            <Grid item xs={12}>
              <Box
                component={'img'}
                loading="lazy"
                height={1}
                width={1}
                src={'https://placehold.co/800x400/f4f7fb/78869a?text=Screenshot+coming+soon'}
                alt="..."
                borderRadius={2}
                maxWidth={1}
                maxHeight={400}
                sx={{
                  objectFit: 'cover',
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant={'h6'} fontWeight={700} gutterBottom>
                Needs, Wants & Savings
              </Typography>
              <Typography component={'p'}>
                Every transaction is automatically sorted into the three
                categories that matter most for your financial health.
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant={'h6'} fontWeight={700} gutterBottom>
                Instant clarity
              </Typography>
              <Typography component={'p'}>
                See at a glance whether you're on track for the month or
                heading towards overspend — before it's too late.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={{ xs: 'flex-start', md: 'space-between' }}
            height={1}
          >
            <Box>
              <Typography variant={'h4'} fontWeight={700} gutterBottom>
                Spending categories
              </Typography>
              <Typography
                color={
                  theme.palette.mode === 'light'
                    ? 'text.secondary'
                    : 'text.primary'
                }
              >
                Stop guessing where your money went. Docket splits every
                transaction into Needs, Wants and Savings so you always know
                exactly how you're spending.
              </Typography>
            </Box>
            <Box component={Card} marginTop={{ xs: 2, md: 0 }} boxShadow={0}>
              <CardContent sx={{ padding: { xs: 2, sm: 4 } }}>
                <Typography component={'p'}>
                  "Docket completely changed how I think about spending. Seeing
                  my Needs vs Wants breakdown each month keeps me accountable
                  without feeling restrictive."
                </Typography>
                <Box marginTop={{ xs: 2, sm: 4 }}>
                  <Typography variant={'subtitle1'} sx={{ fontWeight: 700 }}>
                    Sarah M.
                  </Typography>
                  <Typography color="text.secondary">Docket user</Typography>
                </Box>
              </CardContent>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CaseStudy1;
